module.exports = __webpack_public_path__ + "static/media/chair.b09a0b41.svg";